<div class="flex flex-nowrap overflow-x-scroll no-scrollbar select-none touch-pan-x {{ itemGapClass }} {{ sliderClass }}" #slider>
  @for (item of items; track item) {
    <ng-container
      *ngTemplateOutlet="itemTemplate; context: { $implicit: item }">
    </ng-container>
  }
</div>

